import {
	SET_REVIEWS_FILTERS,
	UPDATE_RATING_FILTER,
	UPDATE_MODEL_FILTER,
	UPDATE_TYPE_FILTER
} from './types';

/**
 * @param {FilterState} reviewsFilters
 * @returns {Object} action
 * @returns {string} action.type - SET_REVIEWS_FILTERS
 * @returns {FilterState} action.payload - reviewsFilters
 */
export const setReviewsFilters = (reviewsFilters) => {
	return {
		type: SET_REVIEWS_FILTERS,
		payload: reviewsFilters
	};
};

/**
 * @param {string} rating 1-5
 * @param {boolean} checked
 * @returns {Object} action
 * @returns {string} action.type - UPDATE_RATING_FILTER
 * @returns {Object} action.payload
 * @returns {string} action.payload.rating - 1-5
 * @returns {boolean} action.payload.checked
 */
export const updateRatingFilters = (rating, checked) => {
	return {
		type: UPDATE_RATING_FILTER,
		payload: { rating, checked }
	};
};

/**
 * @param {string} model
 * @param {boolean} checked
 * @returns {Object} action
 * @returns {string} action.type - UPDATE_MODEL_FILTER
 * @returns {Object} action.payload
 * @returns {string} action.payload.model
 * @returns {boolean} action.payload.checked
 */
export const updateModelFilters = (model, checked) => {
	return {
		type: UPDATE_MODEL_FILTER,
		payload: { model, checked }
	};
};

/**
 * @param {string} type all | sales | service
 * @returns {Object} action
 * @returns {string} action.type - UPDATE_TYPE_FILTER
 * @returns {string} action.payload - type
 */
export const updateTypeFilters = (type) => {
	return {
		type: UPDATE_TYPE_FILTER,
		payload: type
	};
};
